@if (!ordered) {
  <app-bread-crumbs
    [(breadcrumbs)]="breadcrumbs"
  ></app-bread-crumbs>
}
<div class="container px-0">
  <div class="px-3">
    <h1>{{ "PREORDER_CONDITIONS" | translate | formatStringYear }}</h1>

    @if ((!bico && !zeg) && applicationService.getSelectCompanyGroupCode() !== 'GHO') {
      <div class="mt-4">{{ "PAYCOND_EXPLAIN" | translate }}</div>
    }
    @if (applicationService.getSelectCompanyGroupCode() === 'GHO') {
      <div class="mt-4">{{ "PAYCOND_EXPLAIN_GHOST" | translate }}</div>
    }

    @if (accountLoaded) {
      <div>
        @if (groupId === 'direct' && showFlex) {
          <div class="px-2 mx-0 row odd">
            <div class="px-0 mt-2 col-4">
              <strong>{{ "FLEX_CONDITIONS" | translate }}</strong>
            </div>
            <div class="mt-2 col-8">
              <div class="d-block">
                <input
                  class="me-2"
                  type="checkbox"
                  name="flex_discount"
                  value="true"
                  id="flex_8"
                  [(ngModel)]="flex_discount"
                  (change)="checkSelection()"
                  />
                <label
                  for="flex_8"
              [innerHTML]="
                'PAYCOND_FLEX' + translationKey | translate | formatStringYear
              "
                ></label>
              </div>
            </div>
            @if (ordered) {
              <div class="px-3 col-md-12">
                <app-sent-basket-overview></app-sent-basket-overview>
              </div>
            }
          </div>
        }
        @if (groupId === 'Lapierre') {
          <div class="px-2 mx-0 row odd">
            <div class="px-0 mt-2 col-4">
              <strong>{{ "FLEX_CONDITIONS" | translate }}</strong>
            </div>
            <div class="mt-2 col-8">
              <div class="mt-2 col-8">
                <input
                  class="me-2"
                  type="radio"
                  name="LapierreStandard"
                  value="4"
                  id="lapierre_1"
                  [(ngModel)]="selected"
                  (change)="checkSelection()"
                  />
                <label
                  for="lapierre_1"
              [innerHTML]="
                'PAYCOND_FLEX_1' + translationKey | translate | formatStringYear
              "
                ></label>
                <div class="d-block">
                  <input
                    class="me-2"
                    type="radio"
                    name="LapierreStandard"
                    value="5"
                    id="lapierre_2"
                    [(ngModel)]="selected"
                    (change)="checkSelection()"
                    />
                  <label
                    for="lapierre_2"
                [innerHTML]="
                  'PAYCOND_FLEX_2' + translationKey | translate | formatStringYear
                "
                  ></label>
                  <div class="d-block">
                    <input
                      class="me-2"
                      type="radio"
                      name="LapierreStandard"
                      value="6"
                      id="lapierre_3"
                      [(ngModel)]="selected"
                      (change)="checkSelection()"
                      />
                    <label
                      for="lapierre_3"
                  [innerHTML]="
                    'PAYCOND_FLEX_3' + translationKey | translate | formatStringYear
                  "
                    ></label>
                  </div>
                </div>
              </div>
              @if (ordered) {
                <div class="px-3 col-md-12">
                  <app-sent-basket-overview></app-sent-basket-overview>
                </div>
              }
            </div>
          </div>
        }
        @if (!bico && !zeg) {
          <div class="px-2 mx-0 row odd" [ngClass]="{'hideDetails':groupId === 'all'}">
            <div class="px-0 mt-2 col-4">
              <strong
                >{{ "STANDARD_CONDITIONS" | translate | formatStringYear }}@if (groupId !== 'all') {
                ***
                }</strong
                >
              </div>
              <div class="mt-2 col-8">
                <input
                  class="me-2"
                  type="radio"
                  name="Standard"
                  value="0"
                  id="standard_1"
                  [(ngModel)]="selected"
                  (change)="checkSelection()"
                  />
                <label
                  for="standard_1"
              [innerHTML]="
                'PAYCOND_FLEX_STANDARD_1' + translationKey
                  | translate
                  | formatStringYear
              "
                ></label>
                <div class="d-block">
                  <input
                    class="me-2"
                    type="radio"
                    name="Standard"
                    value="1"
                    id="standard_4"
                    [(ngModel)]="selected"
                    (change)="checkSelection()"
                    />
                  <label
                    for="standard_4"
                [innerHTML]="
                  'PAYCOND_FLEX_STANDARD_2' + translationKey
                    | translate
                    | formatStringYear
                "
                  ></label>
                </div>
              </div>
            </div>
            @if (groupId === '00002') {
              <div class="px-2 mx-0 row odd">
                <div class="px-0 mt-2 col-4">
                  <strong
                    >{{ "CONDITIONS" | translate }} ({{
                    "TIMESLOT_02" | translate
                    }})</strong
                    ><br />
                  </div>
                  <div class="mt-2 col-8">
                    <div class="d-block">
                      <input
                        class="me-2"
                        type="radio"
                        name="Winter1"
                        value="0"
                        id="winter1_3"
                        [(ngModel)]="selected"
                        (change)="checkSelection()"
                        />
                      <label
                        for="winter1_3"
                [innerHTML]="
                  'PAYCOND_FEBMRT_1' + translationKey | translate | formatStringYear
                "
                      ></label>
                    </div>
                    <div class="d-block">
                      <input
                        class="me-2"
                        type="radio"
                        name="Winter1"
                        value="1"
                        id="winter1_7"
                        [(ngModel)]="selected"
                        (change)="checkSelection()"
                        />
                      <label
                        for="winter1_7"
                [innerHTML]="
                  'PAYCOND_FEBMRT_2' + translationKey | translate | formatStringYear
                "
                      ></label>
                    </div>
                  </div>
                </div>
              }
              @if (groupId === '004') {
                <div class="px-2 mx-0 row odd">
                  <div class="px-0 mt-2 col-4">
                    <strong
                      >{{ "CONDITIONS" | translate }} ({{
                      "TIMESLOT_04" | translate
                      }})</strong
                      ><br />
                    </div>
                    <div class="mt-2 col-8">
                      <div class="d-block">
                        <input
                          class="me-2"
                          type="radio"
                          name="Winter2_2"
                          value="0"
                          id="winter2_2"
                          [(ngModel)]="selected"
                          (change)="checkSelection()"
                          />
                        <label
                          for="winter2_2"
                [innerHTML]="
                  'PAYCOND_APRMAY_1' + translationKey | translate | formatStringYear
                "
                        ></label>
                      </div>
                      <div class="d-block">
                        <input
                          class="me-2"
                          type="radio"
                          name="Winter2_6"
                          value="1"
                          id="winter2_6"
                          [(ngModel)]="selected"
                          (change)="checkSelection()"
                          />
                        <label
                          for="winter2_6"
                [innerHTML]="
                  'PAYCOND_APRMAY_2' + translationKey | translate | formatStringYear
                "
                        ></label>
                      </div>
                    </div>
                  </div>
                }
                @if (groupId === 'DEMO' || groupId === 'REPAIR') {
                  <div
                    class="px-2 mx-0 row odd"
                    >
                    @if (groupId === 'DEMO') {
                      <div class="px-0 mt-2 col-4">
                        <strong>{{ "DEMO_CONDITIONS" | translate }}</strong>
                      </div>
                    }
                    @if (groupId === 'REPAIR') {
                      <div class="px-0 mt-2 col-4">
                        <strong>{{ "REPAIR_CONDITIONS" | translate }}</strong>
                      </div>
                    }
                    <div class="mt-2 col-8">
                      <div class="d-block">
                        <input
                          class="me-2"
                          type="checkbox"
                          name="Demodiscount"
                          value="3"
                          id="flex_8_c"
                          [(ngModel)]="selected"
                          (change)="checkSelection()"
                          />
                        <label for="flex_8_c">{{ "PAYCOND_DEMO" | translate }}</label>
                      </div>
                    </div>
                    @if (ordered) {
                      <div class="px-3 col-md-12">
                        <app-sent-basket-overview></app-sent-basket-overview>
                      </div>
                    }
                  </div>
                }
              }
              @if (zeg || bico) {
                <div
                  class="px-2 mx-0 row odd"
                  >
                  <div class="px-0 my-2 col-4">
                    @if (bico) {
                      <strong>{{ "BICO_CONDITIONS_APPLIED" | translate }}</strong>
                    }
                    @if (zeg) {
                      <strong>{{ "ZEG_CONDITIONS_APPLIED" | translate }}</strong>
                    }
                  </div>
                  @if (ordered) {
                    <div class="px-3 col-md-12">
                      <app-sent-basket-overview></app-sent-basket-overview>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
        @if (basket) {
          <app-bottom-navbar [fixed]="true">
            <ng-container *ngTemplateOutlet="options"></ng-container>
          </app-bottom-navbar>
        }
        <ng-template #options>
          @if (basket && groupId !== 'Lapierre' && !bico && !zeg && groupId !== 'all') {
            <div
              class="ps-0 pe-2 mb-2 col-md-12"
              >
              @if (applicationService.getSelectCompanyGroupCode() === 'GHO') {
                {{ "PAYCOND_NOTES_TWO" | translate }}
              }
            </div>
          }
          @if (basket) {
            <div class="ps-0 pe-2 col-md-12 d-flex justify-content-between">
              <button class="float-left btn btn-lg btn-dark" (click)="back()">
                {{ "BACK" | translate }}
              </button>
              <button
                class=" btn btn-lg btn-success"
                (click)="checkout()"
        [disabled]="
          !basket.ordering_allowed || !valid || loading ? 'disabled' : ''
        "
        [ngClass]="
          !basket.ordering_allowed || !valid || loading ? 'disabled' : ''
        "
                >
                {{ "SEND" | translate }}
              </button>
            </div>
          }
        </ng-template>
      </div>
